import React, { useRef, useEffect, useState } from 'react';
import $ from 'jquery';
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { Document, Page, pdfjs} from "react-pdf";
import Draggable from 'react-draggable';
import samplepdf from './sample.pdf';
import PdfMerge from './pdfMarge';
import useMouse from '@react-hook/mouse-position'
import './selectmarkeronpdf.css';

import FilePreview from "react-file-preview-latest";
import fontkit from '@pdf-lib/fontkit'
// import './e_sign.css'
import domtoimage from 'dom-to-image';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import {Modal, Button, Table} from 'react-bootstrap';

import { degrees, PDFDocument, rgb, StandardFonts } from 'pdf-lib';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const SelectMarkOnPdf=()=>{
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
 
 const [filedata, setfiledata]=useState('')
 const [addPosition, setAddPosition]=useState([])
 const [showPositionModal, setshowPositionModal]=useState(false)
 const initPosition={
  x:'',y:'',
  name:'',
  email:'',
  mobile:'',
  pageNumber:1
}
 const [positionofsign, setpositionofsign]=useState(initPosition)
 const cheildelement=useRef()
    
  /*When document gets loaded successfully*/
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
    setpositionofsign({...positionofsign, pageNumber:1})
    $( "#cheild_Elem_drag_pdf" ).draggable({containment: "parent", drag: function( event, ui ) {
      let newPosX = ui.offset.left - $('#parrent_Elem_drag_pdf').offset().left;
      let newPosY = ui.offset.top - $('#parrent_Elem_drag_pdf').offset().top;
      setpositionofsign({...positionofsign, x:newPosX, y:newPosY})
  }});
  }
  
  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
    setpositionofsign({...positionofsign, pageNumber:positionofsign.pageNumber+offset})
  }
  
  function previousPage() {
    changePage(-1);
  }
  
  function nextPage() {
    changePage(1);
  }
  const generateSignDocument=async()=>{
    var binary_string = window.atob(filedata.split(',')[1]);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    const pdfDoc =await PDFDocument.load(bytes.buffer)
    pdfDoc.registerFontkit(fontkit)
    const pages = pdfDoc.getPages()
    const firstPage = pages[pageNumber-1]
    const { width, height } = firstPage.getSize()
    const jpgImageBytes = await fetch('/nodeHtmlToImage').then((res) => res.arrayBuffer())
    const jpgImage = await pdfDoc.embedPng(jpgImageBytes)
   
    firstPage.drawImage(jpgImage, {
      x: positionofsign.x,
      y: height-positionofsign.y-80,
      width: 150,
      height: 80,
    })
   
    const pdfBytes = await pdfDoc.saveAsBase64()
    console.log("data:application/pdf;base64," + pdfBytes)
    // window.open("data:application/pdf;base64,"+pdfBytes);
    window.open("data:application/pdf;base64," + pdfBytes);
  }  
  const saveSignaturePosition=()=>{
    setshowPositionModal(!showPositionModal)
      
  }

  console.log(positionofsign,pageNumber, addPosition)
  useEffect(()=>{
  }, [])
  return (
    <div>
    <div>
      <PdfMerge getmergedocsData={(ev)=>{
        if(ev){
          setfiledata("data:application/pdf;base64,"+ev)
        }
      }}/>
      {/*
        
        <input type='file' accept="application/pdf" onChange={(ev)=>{
            let file=ev.target.files[0]
            if(file!==undefined){
              console.log(file)
              var reader = new FileReader();
              reader.onload = function (e) {
                setfiledata(e.target.result)
                console.log(e.target.result)
              }
              reader.readAsDataURL(file);
            }
        }}/>
        <FilePreview
          type={"file"}
          url={'http://www.africau.edu/images/default/sample.pdf'}        
          onError={(ev)=>{}}
        />
      */}
    </div>
    <div>
    {filedata&&
    <div>
    <div>
        <div
          style={{
            display:'inline-block'
          }} id='parrent_Elem_drag_pdf'>
        
          <Document
            
            file={filedata}
            onLoadSuccess={onDocumentLoadSuccess}
            
          >
          {/*
            {Array.from(Array(numPages).keys()).map(page=>(
              
            ))}
          */}
            <Page pageNumber={pageNumber}
            />

            </Document>
              <div
              ref={cheildelement}
              className='drgelement' 
              id='cheild_Elem_drag_pdf'>
                <div>
                  <div>
                    <span>Amit</span>
                  </div>
                  <div>
                    <span>sign</span>
                  </div>
                </div>
              </div>
          </div>
      </div>
      <div>
        <div className="pagec">
          Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
        </div>
        <div className="buttonc">
        <button
          type="button"
          disabled={pageNumber <= 1}
          onClick={previousPage}
          className="Pre"
        >
          Previous
        </button>
        <button
          type="button"
          disabled={pageNumber >= numPages}
          onClick={nextPage}
           
        >
          Next
        </button>
        </div>
        <button
        onClick={()=>{
          saveSignaturePosition()
        }}
        >Save Signature</button>
        <button onClick={()=>{
          generateSignDocument()
        }}>modify pdf</button>
        
      </div>
    </div>    
    }
    </div>
      <Modal show={showPositionModal} onHide={()=>{
        setshowPositionModal(false)
      }}>
          <Modal.Header closeButton>
            <Modal.Title>Enter Sign Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <input type='text' className='form-control'
                 placeholder='Enter Name'
                 value={positionofsign.name}
                 onChange={(ev)=>setpositionofsign({...positionofsign, name:ev.target.value})}
                 />
                 <br/>

                 <br/>
              <input type='email'
                value={positionofsign.email}
                onChange={(ev)=>setpositionofsign({...positionofsign, email:ev.target.value})}
                 className='form-control' placeholder='Enter Email'/>
                 <br/>

              <input type='text' 
                  value={positionofsign.mobile}
                  onChange={(ev)=>setpositionofsign({...positionofsign, mobile:ev.target.value})}
                  className='form-control' placeholder='Enter Mobile Number'/>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={()=>{
              // setpositionofsign({...positionofsign, pageNumber:1})
              // console.log(pageNumber,positionofsign)
              setAddPosition([...addPosition, positionofsign])
              setshowPositionModal(false)
              setpositionofsign({...initPosition})
            }}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
    </div>
  );
};

export default SelectMarkOnPdf;